import React, { useState } from "react";
import { getApiUrl } from "../../services/api_service";
import {  IconButton, Snackbar } from "@mui/material";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { saveAs } from "file-saver";
import { rcolor } from "../../style2";

export function DownloadFormButton(props) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const getData = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }

        setError("");
        setLoading(true);
        fetch(
            `${getApiUrl()}/patientform/downloadbyid/${props.form.id}`,
            {
                method: "GET",
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    response.blob().then(blob => {
                        const contentDisposition = response.headers.get('content-disposition');
                        let filename = 'form.docx';
                        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            var matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }
                        saveAs(blob, filename);
                    });
                } else {
                    response.json().then(data => {
                        setError(data.error);
                    }).catch(err => {
                        console.log(err);
                        setError("An error occured");
                    });
                }
            }).catch(err => {
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            });
    };

    return <>
        <IconButton title="Download Form (docx)" disabled={loading}
            onClick={() => { getData(); }}>
            {props.color ? (
                <DownloadOutlinedIcon color={props.color} sx={{fontSize:"2rem"}} />
            ) : (
                <DownloadOutlinedIcon sx={{ color: rcolor, fontSize:"2rem" }} />
            )}
        </IconButton>
        {error !== "" ? <Snackbar
            open={error !== ""}
            autoHideDuration={6000}
            onClose={() => { setError("") }}
            message={error}
        /> : null}
    </>;
}